import React, { FC, useState, FormEvent } from "react";

import Modal from "../../atoms/Modal";

import styles from "./NavigationVideoPasswordModal.module.scss";

type Props = {
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (password: string) => void;
};

const NavigationVideoPasswordModal: FC<Props> = ({
  isSubmitting,
  onClose,
  onSubmit,
}) => {
  const [password, setPassword] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit(password);
  };

  return (
    <Modal centered className={styles.modal} hasCloseMark onClose={onClose}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <p className={styles.title}>ナビ動画ページ</p>
        <label className={styles.label} htmlFor="navigation-video-password">
          パスワードを入力してください
        </label>
        <input
          className={styles.input}
          id="navigation-video-password"
          required
          autoComplete="current-password"
          type="password"
          value={password}
          onChange={event => setPassword(event.target.value)}
        />
        <button
          className={styles.submitButton}
          disabled={!password || isSubmitting}
          type="submit"
        >
          ログイン
        </button>
      </form>
    </Modal>
  );
};

export default NavigationVideoPasswordModal;
